import { render, staticRenderFns } from "./suppliersaleprice.vue?vue&type=template&id=0c0a56ff"
import script from "./suppliersaleprice.vue?vue&type=script&lang=js"
export * from "./suppliersaleprice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports